import React from 'react'
import {_, DATE_REVERSE_2_FORMAT, dateFormatter} from 'plugins/i18n'
import {Row} from '../ReservationSummary/Components'
import {COND_PAYINADVANCE} from 'app/_server/database/constants'
import Text from 'app/Components/twComponents/Text'
import {Icon} from 'plugins/icons'
import {glyphs} from 'app/Components/Icon'
import {calcNumDays} from 'app/lib'
import {NewsletterForm} from 'app/Pages/HomePage/NewsletterSignup'

export const ConfirmationPageHeader = ({
	contract,
}: {
	contract: Pick<Contract, 'client'>
}) => {
	const {client} = contract || {}
	const {name} = client || {}
	const {first} = name || {}

	return (
		<div className="flex flex-col">
			<Text variant="heading3XL" className="py-6">
				{first}, {_`youAreGoingOnTripSoon`}!
			</Text>
			<div className="flex flex-col gap-2">
				<Text variant="base" className="font-bold">
					{_`ConfirmationHeaderLine1`}
				</Text>
				<Text variant="base">{_`ConfirmationHeaderLine2`}</Text>
				<Text variant="base" className="flex items-center gap-2 py-2">
					<Icon glyph={glyphs.MAIL} className="text-tertiary" />
					{_`ConfirmationHeaderLine3`}
				</Text>
			</div>
		</div>
	)
}

export const DateRangePanel = ({
	contract,
}: {
	contract: Pick<Contract, 'beginDate' | 'endDate'>
}) => {
	const {beginDate, endDate} = contract || {}
	const stayDays = calcNumDays(beginDate, endDate)

	const beginDateFormat = dateFormatter(beginDate, DATE_REVERSE_2_FORMAT)
	const endDateFormat = dateFormatter(endDate, DATE_REVERSE_2_FORMAT)

	return (
		<ul className="bg-capGoldLight flex flex-col gap-2">
			<Row
				valueLeft={
					<span>
						{stayDays} {stayDays > 1 ? _`nights` : _`night`}
					</span>
				}
				rowWrapClassName="font-bold"
			/>
			<Row
				valueLeft={
					<span>
						{_`Arrival`}: {beginDateFormat}
					</span>
				}
			/>
			<Row
				valueLeft={
					<span>
						{_`Departure`}: {endDateFormat}
					</span>
				}
			/>
		</ul>
	)
}

export const GuestsPanel = ({
	contract,
}: {
	contract: Pick<Contract, 'adults' | 'kids' | 'babies'>
}) => {
	const {adults, kids, babies} = contract || {}

	return (
		<ul className="bg-capGoldLight flex flex-col gap-2">
			<Row valueLeft={_('NumberOfGuests')} rowWrapClassName="font-bold" />
			{adults ? (
				<Row
					valueLeft={
						<span>
							{adults} {adults > 1 ? _`adults` : _`adult`}
						</span>
					}
				/>
			) : null}
			{kids ? (
				<Row
					valueLeft={
						<span>
							{kids} {kids > 1 ? _`kids` : _`kid`}
						</span>
					}
				/>
			) : null}
			{babies ? (
				<Row
					valueLeft={
						<span>
							{babies} {babies > 1 ? _`babies` : _`baby`}
						</span>
					}
				/>
			) : null}
		</ul>
	)
}

export const AdditionalOptionsPanel = ({
	contract,
}: {
	contract: Pick<Contract, 'options'>
}) => {
	const {options} = contract || {}

	const extrasPayInAdvance = options.filter(
		({condition}) => condition === COND_PAYINADVANCE
	)

	if (!extrasPayInAdvance?.length) return null

	return (
		<ul className="bg-capGoldLight flex flex-col gap-2">
			<Row
				valueLeft={_('AdditionalOptionsConfirmationLabel')}
				rowWrapClassName="font-bold"
			/>
			{extrasPayInAdvance.map(({optionId, price, count}, i) => (
				<Row key={i} valueLeft={_(optionId)} />
			))}
		</ul>
	)
}

export const InsurancePanel = ({
	contract,
}: {
	contract: Pick<Contract, 'hasInsurance'>
}) => {
	const {hasInsurance} = contract || {}

	return (
		<ul className="bg-capGoldLight flex flex-col gap-2">
			<Row
				valueLeft={_('InsuranceConfirmationLabel')}
				rowWrapClassName="font-bold"
			/>
			<Row valueLeft={hasInsurance ? _`Yes` : _`No`} />
		</ul>
	)
}

export const NewsletterPanel = () => {
	return (
		<div className="flex flex-col items-start justify-start gap-2">
			<Row valueLeft={_('newsletterSubtitle')} />
			<NewsletterForm />
		</div>
	)
}
